// „Nie pamiętasz hasła?" — podaj e-mail, a na adres aktywnego konta przyjdzie link
// do ustawienia nowego hasła (ważny 60 min). Odpowiedź API jest ZAWSZE ta sama,
// więc i komunikat jest jeden: strona nie zdradza, czy konto istnieje.
// Używany w LoginForm (przełącznik) i na /konto/ustaw-haslo po wygasłym linku.

import { useState, type FormEvent } from 'react'
import { authApi } from '../../lib/auth'
import { BTN_PRIMARY, Field, INPUT, Notice } from './AuthUi'

export function ForgotPasswordForm({ initialEmail = '' }: { initialEmail?: string }) {
  const [email, setEmail] = useState(initialEmail)
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState<string | null>(null)
  const [sentTo, setSentTo] = useState<string | null>(null)

  const submit = (e: FormEvent) => {
    e.preventDefault()
    const addr = email.trim()
    setBusy(true)
    setErr(null)
    authApi.forgot(addr).then(
      () => { setSentTo(addr); setBusy(false) },
      (e: Error) => { setErr(e.message); setBusy(false) },
    )
  }

  if (sentTo) {
    return (
      <Notice tone="ok">
        <div>
          Jeśli <span className="font-semibold">{sentTo}</span> to adres aktywnego konta, właśnie wysłaliśmy na niego
          link do ustawienia nowego hasła. Link jest ważny 60 minut — sprawdź też folder ze spamem.
        </div>
        <div className="mt-1 text-xs">
          Nic nie przyszło? Konto bez adresu e-mail albo jeszcze nieaktywne (zaproszone) obsługuje admin.
        </div>
      </Notice>
    )
  }

  return (
    <form onSubmit={submit} className="flex flex-col gap-3">
      {err && <Notice tone="error" onClose={() => setErr(null)}>{err}</Notice>}
      <Field label="E-mail konta">
        <input
          className={INPUT} type="email" value={email} onChange={(e) => setEmail(e.target.value)}
          autoComplete="email" autoCapitalize="none" spellCheck={false} autoFocus required
        />
      </Field>
      <button type="submit" disabled={busy || !email.includes('@')} className={`${BTN_PRIMARY} self-start`}>
        {busy ? 'Wysyłanie…' : 'Wyślij link'}
      </button>
    </form>
  )
}
